export default "__VITE_ASSET__BDIcoUj9__"